(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-icon-text-columns"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const content = document.querySelector(".icon-text-columns-left .content-wrapper");
    const btn = document.querySelector(".icon-text-columns-left .read-more-btn");
    
    if (!content || !btn) return;
        
    btn.addEventListener("click", function() {
    if (content.classList.contains("expanded")) {
      content.classList.remove("expanded");      
      btn.textContent = "Read more";
    } else {
      content.classList.add("expanded");      
      btn.textContent = "Read less";
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-indoor-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
  const content = document.querySelector(".indoor-content-wrapper");
  const btn = document.querySelector(".read-more-btn");

  if (!content || !btn) return;

  // Show button only if content exceeds 110px
  if (content.scrollHeight > 110 && window.innerWidth <= 768) {
    btn.style.display = "inline-block";
  }

  btn.addEventListener("click", function() {
    if (content.classList.contains("expanded")) {
      content.classList.remove("expanded");
      content.style.maxHeight = "110px";
      btn.textContent = "Read more";
    } else {
      content.classList.add("expanded");
      content.style.maxHeight = content.scrollHeight + "px";
      btn.textContent = "Read less";
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heating-systems-grid"] && !Shopify.designMode) return;
  try {
    
	
	document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".products.carousel .carousel__slide");
  
  if (slides.length > 5) {
    const navDivs = document.querySelectorAll(".heating-systems-grid .products .flickity-nav");

    navDivs.forEach(div => {
      div.style.display = "flex";
    });
  }
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-custom-icon-text-columns"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const content = document.querySelector(".icon-text-columns-left .content-wrapper");
    const btn = document.querySelector(".icon-text-columns-left .read-more-btn");
    
    if (!content || !btn) return;
        
    btn.addEventListener("click", function() {
    if (content.classList.contains("expanded")) {
      content.classList.remove("expanded");      
      btn.textContent = "Read more";
    } else {
      content.classList.add("expanded");      
      btn.textContent = "Read less";
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-custom-indoor-text"] && !Shopify.designMode) return;
  try {
    
// document.addEventListener("DOMContentLoaded", function() {
//   const content = document.querySelector(".indoor-content-wrapper");
//   const btn = document.querySelector(".read-more-btn");

//   btn.addEventListener("click", function() {
//     if (content.classList.contains("expanded")) {
//       content.classList.remove("expanded");
//       btn.textContent = "Read more";
//     } else {
//       content.classList.add("expanded");
//       btn.textContent = "Read less";
//     }
//   });
// });

  (function () {
  var sections = document.querySelectorAll('.custom-indoor-text');
  if (!sections.length) return;

  sections.forEach(function (root) {
    var content = root.querySelector('.indoor-content-wrapper');
    var btn = root.querySelector('.rtm__toggle');
    var more = root.querySelector('.rtm__more');
    var less = root.querySelector('.rtm__less');
    if (!content || !btn) return;

    // measure
    content.classList.add('is-expanded');
    var realHeight = content.scrollHeight;
    content.classList.remove('is-expanded');
    content.classList.add('is-collapsed');

    var lineHeight = parseFloat(getComputedStyle(content).lineHeight);
    var maxHeight = lineHeight * 4;

    if (realHeight <= maxHeight) {
      btn.style.display = "none";
      return;
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
        e.stopImmediatePropagation();
        console.log('444');
      var collapsed = content.classList.contains('is-collapsed');
      if (collapsed) {
        content.classList.remove('is-collapsed');
        content.classList.add('is-expanded');
        more.hidden = true;
        less.hidden = false;
      } else {
        content.classList.remove('is-expanded');
        content.classList.add('is-collapsed');
        more.hidden = false;
        less.hidden = true;
      }
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["other-application-systems-grid"] && !Shopify.designMode) return;
  try {
    
	
	document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".products.carousel .carousel__slide");
  
  if (slides.length > 5) {
    const navDivs = document.querySelectorAll(".heating-systems-grid .products .flickity-nav");

    navDivs.forEach(div => {
      div.style.display = "flex";
    });
  }
});




  } catch(e) { console.error(e); }
})();
})();
